export const CORE_MODULES = [
    { code: 'core', label: 'Gestor de tareas', description: 'Proyectos, vistas, tareas, automatizaciones, reportes', dependsOn: [], pack: 'core', locked: true },
    { code: 'core.goals', label: 'Objetivos', description: 'Objetivos jerárquicos con indicadores y avance ponderado', dependsOn: ['core'], pack: 'core' },
    { code: 'core.portfolios', label: 'Portafolios', description: 'Grupos de proyectos con avance, semáforo y carga', dependsOn: ['core'], pack: 'core' },
    { code: 'core.external', label: 'Colaboradores externos', description: 'Personas externas con vigencia, entregables e informe de actividades', dependsOn: ['core'], pack: 'core' },
    { code: 'core.corrective', label: 'Acciones correctivas', description: 'Hallazgos, causas y acciones con seguimiento', dependsOn: ['core'], pack: 'core' },
    { code: 'core.risks', label: 'Riesgos', description: 'Registro de riesgos con controles y tratamientos', dependsOn: ['core'], pack: 'core' },
    { code: 'core.meetings', label: 'Reuniones', description: 'Actas con asistentes y compromisos que se vuelven tareas', dependsOn: ['core'], pack: 'core' },
];
export const OrgProfile = { COMPANY: 'COMPANY', PUBLIC_ENTITY: 'PUBLIC_ENTITY', NGO: 'NGO' };
export const ORG_PROFILE_LABEL = { COMPANY: 'Empresa', PUBLIC_ENTITY: 'Entidad pública', NGO: 'ONG o fundación' };
/** Módulos del núcleo que cada perfil enciende (decisión abierta 9 del spec: por ahora, toda la gestión genérica). */
export const CORE_PROFILE_MODULES = {
    COMPANY: CORE_MODULES.map((m) => m.code),
    PUBLIC_ENTITY: CORE_MODULES.map((m) => m.code),
    NGO: CORE_MODULES.map((m) => m.code),
};
/** Cierre de dependencias: los módulos a encender para activar `codes`. */
export function withDependencies(codes, catalog) {
    const byCode = new Map(catalog.map((m) => [m.code, m]));
    const out = new Set();
    const add = (c) => {
        if (out.has(c))
            return;
        const m = byCode.get(c);
        if (!m)
            throw new Error(`Módulo desconocido: ${c}`);
        out.add(c);
        m.dependsOn.forEach(add);
    };
    codes.forEach(add);
    return [...out];
}
/** Los módulos que dependen (directa o indirectamente) de `code`: se apagan con él. */
export function dependents(code, catalog) {
    const out = new Set();
    const walk = (c) => {
        for (const m of catalog)
            if (m.dependsOn.includes(c) && !out.has(m.code)) {
                out.add(m.code);
                walk(m.code);
            }
    };
    walk(code);
    return [...out];
}
/**
 * Alinea los módulos locales con los que la suite dice que tiene la entidad (GUIA-AGENTES.md §3.1 y §4 de la suite).
 * La suite conoce todo el catálogo (Planning lo publica al arrancar, con los submódulos de cada paquete y sus
 * dependencias) y es el único lugar donde se encienden y apagan: lo local queda igual a su lista, con lo que cada uno
 * necesita por si acaso. Devuelve qué encender, qué apagar y los códigos que la suite mandó y Planning no conoce.
 */
export function modulesFromSuite(suiteModules, catalog, current = []) {
    const known = new Set(catalog.map((m) => m.code));
    const enable = withDependencies(['core', ...suiteModules.filter((c) => known.has(c))], catalog);
    const on = new Set(current);
    return {
        enable: enable.filter((c) => !on.has(c)),
        disable: [...on].filter((c) => known.has(c) && c !== 'core' && !enable.includes(c)),
        unknown: suiteModules.filter((c) => !known.has(c)),
    };
}
//# sourceMappingURL=modules.js.map